import HappyAdultIcon from '@stencil/icons/src/HappyAdultIcon/HappyAdultIcon';
import {defaultTheme} from '@stencil/build-theme';
import {getAdultandChildTxt} from '@stencil/hotels-utils/src/common-utils';

import * as S from './PaxInfo.styles';

export default function PaxInfo({
  adultCount = 0,
  childCount = 0,
  showCountTextBelow = false,
  hideIcon = false,
  marginLeft = null,
  childAge = '',
}) {
  return (
    <>
      <S.FlexWrap>
        {!hideIcon ? (
          <>
            {[...Array(adultCount)].map((e, i) => (
              <HappyAdultIcon
                height="1.5rem"
                width="1.5rem"
                fill={defaultTheme.colors.downriver.base}
              />
            ))}{' '}
            {[...Array(childCount)].map((e, i) => (
              <HappyAdultIcon
                height="1rem"
                width="1rem"
                margin="5px 0px 0px 0px"
                fill={defaultTheme.colors.downriver.base}
              />
            ))}
          </>
        ) : null}

        {!showCountTextBelow && (
          <S.TotalPaxCountSpan marginLeft={marginLeft}>
            {getAdultandChildTxt(adultCount, childCount)} {childAge}
          </S.TotalPaxCountSpan>
        )}
      </S.FlexWrap>
      {showCountTextBelow && (
        <S.TotalPaxCountSpan marginLeft={'0px'} marginTop={'5px'}>
          {getAdultandChildTxt(adultCount, childCount)} {childAge}
        </S.TotalPaxCountSpan>
      )}
    </>
  );
}
